
import React from 'react';

const OutsourcingSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Outsourcing Safety Staffing: Benefits and Considerations
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Opting to outsource safety staffing is a strategic decision with numerous benefits, yet it demands thoughtful deliberation.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          <div className="bg-blue-50 p-8 rounded-lg">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              Cost-Effectiveness Analysis
            </h3>
            <p className="text-gray-700 text-center">
              Consider the economic implications of outsourcing safety staffing. Investigate how it might minimize tax obligations, insurance costs for workers' compensation, hiring, and administrative expenses.
            </p>
          </div>
          
          <div className="bg-green-50 p-8 rounded-lg">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              Quality & Professionalism
            </h3>
            <p className="text-gray-700 text-center">
              Examine the staffing firm's evaluation criteria and procedures. How do they guarantee that the safety personnel provided possess the requisite level of knowledge and proficiency?
            </p>
          </div>
          
          <div className="bg-orange-50 p-8 rounded-lg">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-team-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              Scalability & Resources
            </h3>
            <p className="text-gray-700 text-center">
              Do they have the resources to ensure professionals have necessary tools? Can the business scale to meet your needs, plus those of other clients?
            </p>
          </div>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <img 
              src="https://safetyconsultantsusa.com/wp-content/uploads/2024/06/safety-staffing-professionalism.jpg" 
              alt="Safety staffing professionalism and quality assurance"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>
          
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Key Considerations When Choosing
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-question-line text-blue-500 mr-3 mt-1"></i>
                <p className="text-gray-700">
                  <strong>Insurance Coverage:</strong> Do they have appropriate insurance in the event of an error?
                </p>
              </div>
              
              <div className="flex items-start">
                <i className="ri-question-line text-blue-500 mr-3 mt-1"></i>
                <p className="text-gray-700">
                  <strong>Tool Provision:</strong> Do they have the resources to ensure professionals have necessary tools?
                </p>
              </div>
              
              <div className="flex items-start">
                <i className="ri-question-line text-blue-500 mr-3 mt-1"></i>
                <p className="text-gray-700">
                  <strong>Scalability:</strong> Can the business scale to meet your needs and those of other clients?
                </p>
              </div>
              
              <div className="flex items-start">
                <i className="ri-question-line text-blue-500 mr-3 mt-1"></i>
                <p className="text-gray-700">
                  <strong>Evaluation Process:</strong> What criteria do they use to evaluate safety personnel?
                </p>
              </div>
            </div>
            
            <div className="mt-8">
              <button className="w-full bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Discuss Your Requirements
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutsourcingSection;
